import React, { useState, useRef, useEffect } from "react";
import nigthSound from "../../sound/night.mp3";
import daySound from "../../sound/day.mp3";

import SpotBear from "../../sound/montreur-ours.mp3";
import WerewolvesSound from "../../sound/werewolves.mp3";
import dividerImg from "../../img/icon/divider.png";
import { DayNightCycle } from "../../Component/DayNightCycle";
import TabPlayer from "../../Component/TabPlayer";
import InGameButton from "../../Component/Button/in-game-button/InGameButton";
import "./WerewolveGame.css";
import { Divider } from "primereact/divider";
import tagueuleMathis1 from "../../sound/taguelemathis1.mp3";
import tagueuleMathis2 from "../../sound/taguelemathis2.mp3";
import tagueuleMathis3 from "../../sound/taguelemathis3.mp3";
import tagueuleMathis4 from "../../sound/taguelemathis4.mp3";
import tagueuleMathis5 from "../../sound/taguelemathis5.mp3";

const WerewolveGame = () => {
  const [night, setNight] = useState(false);
  const [werewolvesRound, setWerewolvesRound] = useState(false);
  const [partie, SetPartie] = useState(null);

  const nightAudioRef = useRef(new Audio(nigthSound));
  const dayAudioRef = useRef(new Audio(daySound));
  const taGueuleMathisRef = [
    useRef(new Audio(tagueuleMathis1)),
    useRef(new Audio(tagueuleMathis2)),
    useRef(new Audio(tagueuleMathis3)),
    useRef(new Audio(tagueuleMathis4)),
    useRef(new Audio(tagueuleMathis5)),
  ];
  const bearAudioRef = useRef(new Audio(SpotBear));
  const [audio, setAudio] = useState(new Audio(WerewolvesSound));
  const [NbPlayer, setNbPlayer] = useState(0);

  const montreurOurs = () => {
    bearAudioRef.current.currentTime = 0;
    bearAudioRef.current.play();
  };

  audio.volume = 0.3;
  const handlePlay = () => {
    if (night) {
      if (!werewolvesRound) {
        nightAudioRef.current.pause();
        nightAudioRef.current.currentTime = 0; // Rewind NightAudio to the beginning
        audio.play();
        console.log("werewolves");
        fetch(
          `https://home-assistant.lerepaireduphoenix.fr/api/webhook/${process.env.REACT_APP_URL_HOME_ASSISTANT}-werewolvesround`,
          {
            method: "POST",
            redirect: "follow",
          }
        )
          .then((response) => response.text())
          .then((result) => console.log(result))
          .catch((error) => console.log("error", error));
      } else {
        console.log("end Werewolves");

        audio.pause();
        console.log(audio.paused);
        audio.currentTime = 0;

        nightAudioRef.current.play();
        fetch(
          `https://home-assistant.lerepaireduphoenix.fr/api/webhook/${process.env.REACT_APP_URL_HOME_ASSISTANT}-werewolvesnight`,
          {
            method: "POST",
            redirect: "follow",
          }
        )
          .then((response) => response.text())
          .then((result) => console.log(result))
          .catch((error) => console.log("error", error));
      }
      setWerewolvesRound(!werewolvesRound);
    }
  };

  const taGueuleMathis = () => {
    let index = Math.floor(Math.random() * taGueuleMathisRef.length);
    taGueuleMathisRef[index].current.currentTime = 0;
    if (night) {
      nightAudioRef.current.pause();
    } else {
      dayAudioRef.current.pause();
    }
    taGueuleMathisRef[index].current.volume = 1;
    taGueuleMathisRef[index].current.play();
    taGueuleMathisRef[index].current.onended = () => {
      if (night) {
        nightAudioRef.current.play();
      } else {
        dayAudioRef.current.play();
      }
    };
  };

  const newNight = (newNight) => {
    setNight(newNight);
  };

  const handleWerewolves = () => {
    setWerewolvesRound((prevRound) => !prevRound);
  };

  return (
    <div className="werewolvesGame">
      <DayNightCycle
        night={newNight}
        NightAudio={nightAudioRef.current}
        DayAudio={dayAudioRef.current}
      />
      <div className="inGameButtons">
        <InGameButton
          onClick={montreurOurs}
          img={`${process.env.REACT_APP_WEREWOLVES_API_URL}/${process.env.REACT_APP_FOLDER_IMAGES}/icon/bear.png`}
        />
        <InGameButton
          onClick={handlePlay}
          img={`${process.env.REACT_APP_WEREWOLVES_API_URL}/${process.env.REACT_APP_FOLDER_IMAGES}/icon/wolf.png`}
        />
        <InGameButton
          onClick={taGueuleMathis}
          img={`${process.env.REACT_APP_WEREWOLVES_API_URL}/${process.env.REACT_APP_FOLDER_IMAGES}/icon/shushing-face.png`}
        />
      </div>
      <Divider />
      <TabPlayer />
    </div>
  );
};

export default WerewolveGame;
